import { render, staticRenderFns } from "./CustomersAdd.vue?vue&type=template&id=290e7007&scoped=true&"
import script from "./CustomersAdd.vue?vue&type=script&lang=js&"
export * from "./CustomersAdd.vue?vue&type=script&lang=js&"
import style0 from "./CustomersAdd.vue?vue&type=style&index=0&id=290e7007&lang=scss&scoped=true&"
import style1 from "./CustomersAdd.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290e7007",
  null
  
)

export default component.exports